import { render, staticRenderFns } from "./reject-applicationreqPopup.vue?vue&type=template&id=5824696e"
import script from "./reject-applicationreqPopup.vue?vue&type=script&lang=js"
export * from "./reject-applicationreqPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports